import LeftButton from "./LeftButton";
import icoConsultoria from "../../Resources/services/icons/icon-consultoria.svg";
import icoIngame from "../../Resources/services/icons/icon-ingame.svg";
import icoExperiencias from "../../Resources/services/icons/icon-experiencias.svg";
import icoEsports from "../../Resources/services/icons/icon-esports.svg"

import icoTitleConsultoria from "../../Resources/services/icons/icon-titulo-consultoria.svg";
import icoTitleIngame from "../../Resources/services/icons/icon-titulo-ingame.svg";
import icoTitleExperiencias from "../../Resources/services/icons/icon-titulo-experiencias.svg";
import icoTitleEsports from "../../Resources/services/icons/icon-titulo-esports.svg"

import bgConsultoria from "../../Resources/services/consulting.jpeg"
import bgIngame from "../../Resources/services/iga.jpeg"
import bgExperiencias from "../../Resources/services/experiences.jpeg"
import bgEsports from "../../Resources/services/esports.jpeg"

import React, {Component} from "react";
import PropTypes from "prop-types";
import gsap from "gsap";
import {SvcConsulting, SvcEsports, SvcGaming, SvcIngame} from "./SvcContent";
import './Services.css';
import MainMenu from "../menu/menu";
import {getFM, isPortrait} from "../../Utilities/utils";
import {injectIntl} from "react-intl";
import {logEvent} from "../../Utilities/AmplitudeService";

class Services extends Component {

    constructor(props) {
        super(props)

        this.state = {
            isAnimating: false,
            selectedItem: {},
            selectedIndex: 0
        };

        this.changeIndex = this.changeIndex.bind(this);
    }

    componentDidMount() {
        this.setState(()=> {
            this.changeIndex(this.props.selectedIndex ?? 0);
        });
        logEvent('page_loaded');
        window.scrollTo(0, 0);
    }

    changeIndex(index) {
        if (this.state.isAnimating) {
            return;
        }

        this.setState({
            isAnimating: true
        });

        const t1 = gsap.timeline({
            paused: true,
            yoyo: true,
            repeat: 1,
            repeatDelay: 0,
            duration: 0.5,
            onRepeat: () => {
                const p = this.sectionsProps[index];
                this.setState({selectedItem: p})
                this.setScroll(p.scroll);
            }
        }).to(['.services-background', '.sep'], {
            duration: 0.4,
            opacity: 0.1,
        }, '0')
        .to(".svc-slide-item", {
            top: "+=20vh",
            stagger: 0.1,
            opacity: 0,
            duration: 0.3,
        }, '0')
        .fromTo([ ".services-content-title", ".svc-title", ".svc-subtitle"], {
            scale: 1,
            opacity: 1,
        },{
            ease: 'power4.easeIn',
//          stagger: 0.15,
            scale: 0.4,
            y: "+=6vh",
            opacity: 0,
            duration: 0.3,
        }, '0')
        .to(".svc-first-line", {
            ease: 'power4.easeIn',
            y: "+=4vh",
            scale: 0,
            duration: 0.2,
        });

        t1.play().then(() => {
            let e = document.getElementById('lb' + index);
            if (e) e.focus();
            this.setState({
                isAnimating: false
            })
        });

    }

    render() {

        this.sectionsProps = [{
            text: 'home_IGA_title',
            icon: icoIngame,
            iconTitle: icoTitleIngame,
            background: bgIngame,
            content: SvcIngame(this.props, this.props.intl.messages),
            scroll: 1
        }, {
            text: 'home_consulting_title',
            icon: icoConsultoria,
            iconTitle: icoTitleConsultoria,
            background: bgConsultoria,
            content: SvcConsulting(this.props, this.props.intl.messages),
            scroll: 0
        }, {
            text: 'home_experiences_title',
            icon: icoExperiencias,
            iconTitle: icoTitleExperiencias,
            background: bgExperiencias,
            content: SvcGaming(this.props, this.props.intl.messages),
            scroll: 0
        }, {
            text: 'home_esports_title',
            icon: icoEsports,
            iconTitle: icoTitleEsports,
            background: bgEsports,
            content: SvcEsports(this.props, this.props.intl.messages),
            scroll: 0
        }];

        return <>
        <section id={'svcId'} className={"services-container"}>
            <img className={"services-background"}
                 src = {this.state.selectedItem.background}
                 alt={''}
            />

            <div className={"services-content " + this.props.className}>
                <div className={"services-menu"}>
                {this.sectionsProps.map((value, index) => {
                    return <LeftButton key={"lb" + index}
                       index={index}
                       icon={value.icon}
                       label={value.text}
                       className={"font-menu"}
                       clickEvent={() => this.changeIndex(index)} />
                })}
                </div>
                <div className={"services-content-right"}>
                    <div className={"services-content-title"}>
                        <img className={"title-icon"}
                             src={this.state.selectedItem.iconTitle}
                             alt={''}/>
                        <span className={"title-text"} ref={this.title}>
                           {getFM(this.state.selectedItem.text)}
                        </span>
                    </div>
                    {this.state.selectedItem.content}
                </div>
            </div>
        </section>
        <MainMenu showPopup={false}
                  topMenu={'#191919'} colorX={'#EE303B'}
                  autoPlay ={true}
                  iconScroll={isPortrait()?'icon-scroll-left':''}
                  hide={isPortrait()?
                      ['#to-top-icon', '#contact-icon', '#ac', '#at'] :
                      ['#to-top-icon', '#contact-icon']}
                  scroll={this.state.selectedItem.scroll}
                  triggerId={'#svcId'} end={'top -15%'} />

        </>
    };

    setScroll(opacity) {
        gsap.to ('.icon-scroll', {
            duration: 0.2,
            opacity: opacity,
        })
    }
}

Services.propTypes = {
    selectedIndex: PropTypes.number,
    title: PropTypes.string,
    subTitle: PropTypes.string,
    className: PropTypes.string,
    children: PropTypes.element,
    clickEvent: PropTypes.func,
    fill: PropTypes.string,
}

Services.defaultProps = {
    selectedIndex: 0,
    fill: '#fff',
    classText: '',
    className: '',
}

export default injectIntl(Services);

